import { render, staticRenderFns } from "./AuthPasswordChange.vue?vue&type=template&id=138b5ba4&scoped=true"
import script from "./AuthPasswordChange.vue?vue&type=script&lang=js"
export * from "./AuthPasswordChange.vue?vue&type=script&lang=js"
import style0 from "./AuthPasswordChange.vue?vue&type=style&index=0&id=138b5ba4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b5ba4",
  null
  
)

export default component.exports